import { RegisterService } from './register.service';
import { OnlyNumberDirective } from './utils/directives/only-numbers.directive';
import { PhoneMaskDirective } from './utils/directives/phonemask.directive';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCommonModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from '@shared/shared.module';
import { LottieAnimationViewModule } from 'ng-lottie';
import { RegisterCompletedComponent } from './register-completed/register-completed.component';
import { RegisterComponent } from './register.component';
import { RegisterRoutingModule } from './register.routing.module';
import { CepDirective } from './utils/directives/cep.directive';
import { CpfMaskDirective } from './utils/directives/cpfmask.directive';
import { CustomDateMaskDirective } from './utils/directives/custom-date-mask.directive';
import { EmailMaskDirective } from './utils/directives/email-mask.directive';

import { NoSpecialCharsTestDirective } from './utils/directives/no-special-chars.directive-test';
import { OnlyLettersAndNumbersDirective } from './utils/directives/only-letters-and-numbers.directive';
import { OnlyLettersDirective } from './utils/directives/only-letters.directive';
import { TrimDirective } from './utils/directives/trim.directive';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

@NgModule({
  imports: [
    CommonModule,
    RegisterRoutingModule,
    MatIconModule,
    MatCommonModule,
    MatLegacyFormFieldModule,
    ReactiveFormsModule,
    MatLegacyInputModule,
    FormsModule,
    MatLegacySelectModule,
    // MatCheckboxModule,
    MatLegacyRadioModule,
    MatProgressBarModule,
    LottieAnimationViewModule.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
    SharedModule,
  ],
  providers: [
    RegisterService,
  ],
  declarations: [
    RegisterComponent,
    RegisterCompletedComponent,
    CpfMaskDirective,
    PhoneMaskDirective,
    CepDirective,
    TrimDirective,
    OnlyLettersDirective,
    OnlyNumberDirective,
    OnlyLettersAndNumbersDirective,
    CustomDateMaskDirective,
    EmailMaskDirective,
    NoSpecialCharsTestDirective,
    NoSpecialCharsTestDirective,
    EmailMaskDirective
  ],
  exports: [
    CpfMaskDirective,
    PhoneMaskDirective,
    CepDirective,
    TrimDirective,
    OnlyLettersDirective,
    OnlyLettersAndNumbersDirective,
    OnlyNumberDirective
  ]
})
export class RegisterModule { }
